<template>
  <div class="pagination">
    <!-- <div class="previ" @click="$emit('one')">
      第一页
    </div> -->
    <el-select
      v-model="Nowpage"
      @change="mychange($event)"
      placeholder="第一页"
    >
      <el-option
        v-for="(item, index) in pageNumArr"
        :key="item"
        :label="item"
        :value="index"
      >
      </el-option>
    </el-select>
    <div class="pagination_heng"></div>
    <div class="next" @click="xiayiye()">下一页</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      Nowpage: 0,
    };
  },
  props: {
    maxPage: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    mychange(e) {
      let page = e;
      this.$emit("Mychange", page + 1);
    },
    xiayiye() {
      this.$emit("next");
      if (this.pageNumArr.length - 1 != this.Nowpage) {
        this.Nowpage++;
      }
    },
  },
  computed: {
    pageNumArr() {
      let arr = [];
      for (let a = 1; a <= this.maxPage; a++) {
        arr.push(`第${a}页`);
      }
      if(this.maxPage == 0){
        arr = ["第一页"]
      }
      return arr;
    },
  },
};
</script>  

<style lang="less" scoped>
/deep/ .el-select {
  flex: 1;
  height: 100%;
  // width: 90px;
  border: none;
  .el-input__inner {
    border: none;
    background: transparent;
    text-align: right;
  }
  .el-select__caret {
    height: 100%;
  }
  .el-input {
    height: 100%;
  }
  .el-input__inner {
    height: 100%;
  }
  .el-input__icon {
    line-height: 2.1875rem;
  }
  .el-scrollbar__view {
    max-height: 1.875rem;
  }
}
// 上下页部分
.pagination {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 0.75rem;
  height: 2.1875rem;
  width: 100%;
  background: #ffffff;
  border: 0.0625rem solid #eeeeee;
}
.previ,
.next {
  flex: 1;
  height: 100%;
  line-height: 2.1875rem;
  font-size: 0.75rem;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #555555;
  cursor: pointer;
}
.pagination_heng {
  margin: 0 2.4375rem 0 0.625rem;
  width: 0.0625rem;
  height: 1.125rem;
  background: #d9d9d9;
}
.previ {
  position: relative;
}
.selectroPaPage {
  position: absolute;
  left: 0;
  right: 0;
  height: 10rem;
  background-color: red;
}
</style>